'use strict';

angular.module('msOnboarding').directive('msAccessCode', [function () {
  return {
    templateUrl: 'onboarding/templates/accessCode.html',
    replace: true,
    restrict: 'EA',
    scope: {
      acField: '=accessCodeField',
      groupField: '=groupField',
      form: '=',
      accessCode: '=msAccessCode',
      accessCodeData: '=msAccessCodeData',
      group: '=group',
      isAccessCodeValidationInProgress: '=msIsAccessCodeValidationInProgress'
    },
    controller: ['$scope', function ($scope) {
      $scope.showAcField = false;
      $scope.initializedWithGroup = !_.isEmpty($scope.group);
      // Dev helper for getting to welcomeScope
      $scope.welcomeScope = $scope.$parent.$parent;
      $scope.filteredAccessCodes = [];
      $scope.setAccessCodes = setAccessCodes;
      $scope.keyUpHandler = keyUpHandler;
      $scope.$watch('acField', function () {
        setAccessCodes();
      });
      $scope.$watch('accessCode', function (newValue) {
        if (!newValue || $scope.form.accessCode.$error.unhandledAccessCode || $scope.form.accessCode.$error.closedAccessCode || $scope.form.accessCode.$error.toManyTries) {
          return;
        }

        $scope.welcomeScope.accessCode = newValue;
      });

      function keyUpHandler() {
        $scope.welcomeScope.isAccessCodeValidationInProgress = true;
      }

      function setAccessCodes() {
        if (!$scope.acField || !$scope.acField.choices) {
          $scope.showAcField = _.isEmpty($scope.accessCode);
          return;
        }
        var list = [];
        if (!$scope.$parent.group) {
          list = _.filter($scope.acField.choices, { enabled: true });
          if ($scope.groupField) {
            // groupField is defined but no group is selected yet
            $scope.showAcField = false;
          } else if (!$scope.$parent.accessCode) {
            $scope.showAcField = true;
          }
        } else {
          var group = $scope.$parent.group;
          list = _.filter($scope.acField.choices, { filterByValue: group, enabled: true });
          // reset access code
          $scope.$parent.accessCode = '';
          if ($scope.form.accessCode) {
            $scope.welcomeScope.accessCode = null;
            $scope.form.accessCode.$setPristine();
          }
          $scope.showAcField = true;
        }
        $scope.filteredAccessCodes = _.sortBy(list, ['positionOrdinal', 'label']);
      }
    }]
  };
}]).directive('msAccessCodeValidator', ['$q', 'customSignupSvc', function ($q, customSignupSvc) {
  var deferred, timeoutID;
  return {
    transclude: true,
    restrict: 'A',
    require: 'ngModel',
    scope: {
      group: '=group',
      isAccessCodeValidationInProgress: '=msIsAccessCodeValidationInProgress'
    },
    link: function link($scope, elem, attr, ctrl) {
      ctrl.$asyncValidators.accessCode = function (value) {
        if (!value) {
          return $q.when(true);
        }
        deferred = $q.defer();
        $scope.isAccessCodeValidationInProgress = true;

        if (timeoutID) {
          clearTimeout(timeoutID);
        }
        timeoutID = setTimeout(function () {
          customSignupSvc.checkAccessCode(value, $scope.group).then(function (data) {
            $scope.$parent.form.accessCode.$setValidity('unhandledAccessCode', true);
            $scope.$parent.form.accessCode.$setValidity('closedAccessCode', true);
            $scope.$parent.form.accessCode.$setValidity('toManyTries', true);
            // Emit event with data for welcomeCtrl to listen to
            $scope.$emit('setAccessCodeData', data);
            $scope.isAccessCodeValidationInProgress = false;
            deferred.resolve();
          }, function (value) {
            $scope.$emit('setAccessCodeData', null);
            $scope.isAccessCodeValidationInProgress = false;
            // This if is for a special case to see if the HTTP Error Code is a 422. A 422
            // signifies the access code needs to be used with Livongo's signup. Due to the
            // way Angular handles validation and the way we render the error, we are setting
            // a separate error code on the form using setValidity.
            if (value.data.errorCode === 'ACCESS_CODE_UNHANDLED_VERSION') {
              $scope.$parent.form.accessCode.$setValidity('unhandledAccessCode', false);
              deferred.resolve();
            } else if (value.data.errorCode === 'ACCESS_CODE_CLOSED_FOR_REGISTRATION') {
              $scope.$parent.form.accessCode.$setValidity('closedAccessCode', false);
              $scope.isAccessCodeValidationInProgress = true;
              deferred.resolve();
            } else if (value.data.errorCode === 'TOO_MANY_REQUESTS') {
              $scope.$parent.form.accessCode.$setValidity('toManyTries', false);
              $scope.isAccessCodeValidationInProgress = true;
              deferred.resolve();
            } else {
              $scope.$parent.form.accessCode.$setValidity('unhandledAccessCode', true);
              $scope.$parent.form.accessCode.$setValidity('closedAccessCode', true);
              $scope.$parent.form.accessCode.$setValidity('toManyTries', true);
              deferred.reject();
            }
          });
        }, 1200);
        return deferred.promise;
      };
    }
  };
}]);